'use client';

import {
  SimpleListing,
  SimpleListingObject,
} from '@th/shared/src/types/SimpleListing';
import React from 'react';
import blurText from '../../helpers/blurText';
import { twMerge } from 'tailwind-merge';
import { useUser } from '../../contexts/UserContext';
import isListingBlurred from '../../helpers/isListingBlurred';

type Props = {
  listing: SimpleListing;
  isBlurred: boolean;
  showData?: boolean;
  className?: string;
};

export default function ListingAddress({
  listing,
  isBlurred,
  showData = true,
  className,
}: Props) {
  return (
    <p className={twMerge(isBlurred && 'blur-xs', className)}>
      {showData
        ? blurText(listing.address.formattedAddressShortOneLiner(), isBlurred)
        : 'Address: Please login'}
    </p>
  );
}
